const currentUser = state => {
  return state.currentUser
}

const currentUserId = state => {
  return state.currentUser.id
}

const currentUserOrgs = state => {
  return state.currentUser.orgs ? state.currentUser.orgs : []
}

const userDataName = (state, getters) => {
  return getters.userData ? `${getters.userData.firstName || ''} ${getters.userData.lastName || ''}` : null
}

const userData = state => {
  return state.userData
}

const userId = state => {
  return state.userData.id
}

const totalUsers = state => {
  return state.totalUsers
}

const userNotificationSettings = state => {
  return state.userNotificationSettings
}

const userGlobalReceiveSetting = state => {
  return state.userNotificationSettings.globalReceive
}

const userById = (state) => (userId) => {
  return state.listData?.find(user => user.id === userId)
}

const usersListTotal = state => {
  return state.total
}

const userPropertyPermissionsTotal = (state) => {
  return state.userPropertyPermissionsTotal
}

const userPropertyTotal = state => {
  return state.userPropertyTotal
}

const orgUsersPagination = state => {
  return state.orgUsersPagination
}

const currentOrgUser = state => {
  return state.currentOrgUser
}

const userTimezone = state => {
  return state.userTimezone
}

export default {
  currentUser,
  currentUserId,
  currentUserOrgs,
  userData,
  userDataName,
  userId,
  userNotificationSettings,
  userGlobalReceiveSetting,
  usersListTotal,
  userById,
  totalUsers,
  currentOrgUser,
  userPropertyPermissionsTotal,
  userPropertyTotal,
  orgUsersPagination,
  userTimezone,
}
